import hasAttr from '../../../general/attr/hasAttr';
import setStyleData from '../../../general/style/setStyleData';

import * as exSelect from '../../../forms/select';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function current(element: HTMLSelectElement, ctx: Context): any {
    ctx.shared.elements.current = element;
    ctx.shared.state.current = {};

    function init(): void {
        settings();
        observer();
        events();
        eventsForm();

        const hiddenSelectStyles = {
            opacity: '0',
            position: 'absolute',
            pointerEvents: 'none',
        };
        setStyleData(element, hiddenSelectStyles);
    }

    // ------------------------------------------------------------------------

    function settings(): void {
        // If there is multiple
        if (element.multiple) {
            ctx.shared.config.type = 'multi';
        }

        // If there is disabled
        if (element.disabled) {
            ctx.shared.config.disabled = element.disabled;
        }

        // If there is width
        if (element.dataset.width != null) {
            ctx.shared.config.width = element.dataset.width;
        }
    }

    function observer(): void {
        exSelect.observeSelect(element, {
            fnChange: function (): any {
                element.dispatchEvent(new Event('change', { bubbles: true }));
            },
            fnSelected: function (): any {
                element.dispatchEvent(new Event('change', { bubbles: true }));
            },
        });
    }

    function events(): void {
        element.addEventListener('change', function (this: HTMLSelectElement): any {
            const value = exSelect.getValue(this);
            ctx.helpers.setValue(value);
        });
    }

    function eventsForm(): void {
        const elForm = element.closest('form');

        if (!elForm) {
            return;
        }

        /*
         * element.addEventListener('change', function (this: HTMLSelectElement) {
         *  const elText = ctx.text.getTextElement();
         *
         *  if (hasClass(elForm, 'was-validated')) {
         *      if (this.checkValidity()) {
         *          addClass(elText, 'is-valid');
         *          removeClass(elText, 'is-invalid');
         *      } else {
         *          addClass(elText, 'is-invalid');
         *          removeClass(elText, 'is-valid');
         *      }
         *  }
         * });
         */

        /*
         * element.addEventListener('invalid', function (this: HTMLSelectElement) {
         *  const elText = ctx.text.getTextElement();
         *
         *  if (hasAttr(elForm, 'novalidate')) {
         *      addClass(elText, 'is-invalid');
         *      removeClass(elText, 'is-valid');
         *  }
         * });
         */

        elForm.addEventListener('submit', function (evt): any {
            if (hasAttr(elForm, 'novalidate')) {
                evt.preventDefault();
            }
        });
    }

    // ------------------------------------------------------------------------

    function getElement(): HTMLSelectElement {
        return element;
    }

    function setValue(value: any): void {
        exSelect.setValue(element, value);
    }

    function clearValue(): void {
        element.value = '';
    }

    function getOptions(): HTMLOptionElement[] {
        return Array.from(element.options);
    }

    function clearOptions(): void {
        element.innerHTML = '';
    }

    // ------------------------------------------------------------------------

    return {
        init,
        getElement,
        setValue,
        clearValue,
        getOptions,
        clearOptions,
    };
}

// ----------------------------------------------------------------------------

export default current;
